export default "__VITE_ASSET__Cp31mHD___"